module.exports = __webpack_public_path__ + "img/purple-1-squiggly-open.4e98c0df.svg";